import { atom } from 'jotai';

export const privateKeyHexAtom = atom<null | string>(null);
